import { Profile as API } from '@src/api/types';
import { baseURL } from '@src/configuration/constants';
import { Profile as Data } from '@src/types';

const Factory = (api: API): Data => ({
  id: api.id,
  avatar: api.profilePicture
    ? api.profilePicture.startsWith('http')
      ? {
          uri: api.profilePicture,
        }
      : {
          uri: `${baseURL}/media/v1/image/${api.profilePicture}`,
        }
    : undefined,
  name: api.name,
  username: api.username,
  bio: api.bio,
  businessCount: api.businessCount,
  checkinsCount: api.checkinsCount,
  coverPhoto: api.coverPhoto,
  followersCount: api.followersCount,
  blocked: api.blocked,
  following: api.following,
  followingsCount: api.followingsCount,
  gender: api.gender,
  mutualFriendsCount: api.mutualFriendsCount,
  public: api.public,
  requested: api.requested,
  socialProfilePicture: api.socialProfilePicture,
  top: api.top,
});

export default Factory;
